import React from "react";

export function Card({ children, style }) {
  return <div style={{ ...styles.card, ...style }}>{children}</div>;
}

export function SectionHeading({ eyebrow, title, subtitle }) {
  return (
    <div style={{ marginBottom: 20 }}>
      {eyebrow && <div style={styles.eyebrow}>{eyebrow}</div>}
      <h2 style={styles.heading}>{title}</h2>
      {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
    </div>
  );
}

export function PrimaryButton({ children, loading, loadingText, className, ...rest }) {
  return (
    <button {...rest} className={`km-btn-primary ${className || ""}`} disabled={loading || rest.disabled} style={{ ...styles.btn, ...(rest.style || {}) }}>
      {loading && <Spinner />}
      {loading ? loadingText || "Please wait…" : children}
    </button>
  );
}

export function SecondaryButton({ children, className, ...rest }) {
  return (
    <button {...rest} className={`km-btn-secondary ${className || ""}`} style={{ ...styles.btnSecondary, ...(rest.style || {}) }}>
      {children}
    </button>
  );
}

export function Spinner() {
  return (
    <span
      style={{
        display: "inline-block", width: 14, height: 14, borderRadius: "50%",
        border: "2px solid rgba(255,255,255,0.4)", borderTopColor: "#fff",
        animation: "km-spin 0.7s linear infinite", marginRight: 8,
        verticalAlign: "-2px",
      }}
    />
  );
}

export function ErrorBanner({ message }) {
  if (!message) return null;
  return (
    <div style={styles.errorBanner}>
      <span style={{ marginRight: 8 }}>⚠</span>
      {message}
    </div>
  );
}

export function EmptyState({ children }) {
  return <div style={styles.empty}>{children}</div>;
}

const styles = {
  card: {
    maxWidth: 760, margin: "0 auto", padding: "26px 24px 28px",
    background: "var(--card)", border: "1px solid var(--line)",
    borderRadius: "var(--radius-lg)", boxShadow: "var(--shadow-card)",
    animation: "km-fade-up 0.35s var(--ease)",
  },
  eyebrow: {
    fontSize: 12, fontWeight: 700, letterSpacing: 1.4, textTransform: "uppercase",
    color: "var(--terracotta)", marginBottom: 6,
  },
  heading: {
    fontFamily: "var(--font-serif)", fontSize: 26, fontWeight: 700,
    color: "var(--ink)", margin: 0,
  },
  subtitle: { fontSize: 14, color: "var(--ink-soft)", marginTop: 6, lineHeight: 1.5 },
  btn: {
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    padding: "13px 26px", borderRadius: 999, border: "none",
    background: "linear-gradient(135deg, var(--terracotta), var(--terracotta-dark))",
    color: "#fff", fontWeight: 700, fontSize: 14.5, cursor: "pointer",
    boxShadow: "0 10px 22px -10px rgba(216,98,43,0.6)",
    transition: "transform 0.12s var(--ease), box-shadow 0.12s var(--ease)",
  },
  btnSecondary: {
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    padding: "9px 16px", borderRadius: 999, border: "1px solid var(--line)",
    background: "#fff", color: "var(--ink)", fontWeight: 600, fontSize: 13,
    cursor: "pointer",
  },
  errorBanner: {
    display: "flex", alignItems: "center", background: "var(--danger-bg)",
    color: "var(--danger)", padding: "11px 14px", borderRadius: "var(--radius-sm)",
    fontSize: 13.5, marginTop: 14, border: "1px solid rgba(179,64,47,0.25)",
  },
  empty: {
    textAlign: "center", color: "var(--ink-soft)", padding: "28px 12px",
    fontSize: 14, fontStyle: "italic",
  },
};
